class ContactCards {
	constructor(selector = ".contact-card") {
		this.selector = selector
		this.activeClass = "active"
		this.cards = Array.from(document.querySelectorAll(this.selector))

		this.init()
	}

	init() {
		if (!this.cards.length) {
			return
		}

		this.cards.forEach(card => {
			card.addEventListener("mouseenter", () => this.setCardState(card, true))
			card.addEventListener("mouseleave", () => this.setCardState(card, false))
			card.addEventListener("focusin", () => this.setCardState(card, true))
			card.addEventListener("focusout", () => this.setCardState(card, false))
		})
	}

	setCardState(card, isActive) {
		card.classList.toggle(this.activeClass, isActive)
	}
}

export default ContactCards
